module.exports = __webpack_public_path__ + "static/img/customer-01-big.61210c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/customer-01-big.png
// module id = im8w
// module chunks = 2